import React, {Component} from "react";
import {configNo, monthOptions, yearOptions} from "../../config";
import * as R from "ramda";
import {configHeaderTeamLeader, getConfigDaily} from "../config";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import moment from "moment";

class DailySalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            month: null,
            year: null,
            tableConfig: [],
            dataTable: [],
        };
    };

    componentDidMount = () => {
        const currentMonth = Number(moment().format("MM"));
        const currentYear = Number(moment().format("YYYY"));

        this.setState((prevValue) => ({
            ...prevValue,
            month: monthOptions.find(item => R.equals(item.value, currentMonth)),
            year: yearOptions.find(item => R.equals(item.value, currentYear)),
            tableConfig: [
                ...configNo,
                ...configHeaderTeamLeader,
                ...getConfigDaily(),
            ],
        }));
    };

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (!R.equals(prevProps.search, this.props.search)) {
            this.handleSearch();
        }
    };

    transformResponse = (data) =>{
        const transformed =  data.map(item=>{
            const {dataSalesDaily={},...rest} = item;
            return {
                ...rest,
                ...dataSalesDaily,
            }
        })
        return transformed
    }

    fetchData = async () => {
        try {
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarianPerCabang,
                setError: this.props.setError,
                menuName: "Dashboard Team Lead - Laporan Harian by Team Leader",
                args:{
                    kodeCabang: [this.props.search],
                    year: this.state.year?.value,
                    month: this.state.month?.value,
                    team: false,
                    employeeIdTeamLeader: this.props.idLeader
                }
            })
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
                this.setState((prevValue) => ({
                  ...prevValue,
                  dataTable: this.transformResponse(res.data.data),
                }));
            }
        } catch (error) {
            this.props.triggerLoading()
            console.log(error)
        }
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = () =>{
        const { month, year } = this.state
        this.setState({
            tableConfig: [
                ...configNo,
                ...configHeaderTeamLeader,
                ...getConfigDaily(month?.value, year?.value),
            ]
        })
        this.fetchData();
    }

    render() {
        return (
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        id="select_options_month"
                        box="search"
                        name="month"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                    />
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                    />
                    <SimpleButton
                        styles={{marginBottom: "15px"}}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                />
            </>
        );
    };
}

export default DailySalesReport;